var map = {
	"./accidents-footer.png": 50032,
	"./boat-footer.png": 22822,
	"./car-footer.png": 5812,
	"./home-footer.png": 49743,
	"./moto-footer.png": 50285,
	"./pab-footer.png": 40113,
	"./travel-footer.png": 36792
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48929;